import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
function trackModalClosed({ modalName }) {
    try {
        SegmentUtils.track({
            event: 'Modal Closed',
            properties: {
                /* eslint-disable camelcase */
                modal_name: modalName,
                /* eslint-enable camelcase */
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackModalClosed',
        });
    }
}
export default trackModalClosed;
